import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addMeal, deleteMeal, updateMeal } from "../services/firebase";
import { estimateNutrition } from "../services/calorieApi";
import {
  addGuestMeal,
  deleteGuestMeal,
  updateGuestMeal,
} from "../services/guestStorage";

export const useMealMutations = (uid) => {
  const queryClient = useQueryClient();
  const isGuest = !uid || uid === "guest";

  // 1. Analyze Meal (supports text + optional image)
  const analyzeMealMutation = useMutation({
    mutationFn: ({ text, image }) => estimateNutrition(text, image),
  });

  // 2. Add Meal
  const addMealMutation = useMutation({
    mutationFn: (mealData) =>
      isGuest ? addGuestMeal(mealData) : addMeal(uid, mealData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meals", uid] });
    },
  });

  // 3. Delete Meal
  const deleteMealMutation = useMutation({
    mutationFn: (mealId) =>
      isGuest ? deleteGuestMeal(mealId) : deleteMeal(uid, mealId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meals", uid] });
    },
  });

  // 4. Update Meal
  const updateMealMutation = useMutation({
    mutationFn: ({ mealId, data }) =>
      isGuest ? updateGuestMeal(mealId, data) : updateMeal(uid, mealId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meals", uid] });
    },
  });

  return {
    analyzeMealMutation,
    addMealMutation,
    deleteMealMutation,
    updateMealMutation,
  };
};
